import { useSelector } from 'react-redux';
import { useAuthTenant } from 'store/auth';
import { Container } from 'Components/Container';
import { Information } from 'Components/Information';
import React from 'react';
import { DefaultTable } from '../../Components/DefaultTable';
import { tableHeader } from './table-header.js';
import { useQueries } from 'react-query';
import { getGapAnalysis } from 'services/gap-analysis';
import { PageHelper } from 'Components/PageHelper';

export const GapAnalysis = () => {
  const selectedTenant = useSelector(useAuthTenant);

  const results = useQueries([
    {
      queryKey: ['companyKey', selectedTenant._id],
      queryFn: () => getGapAnalysis(selectedTenant._id),
      enabled: !!selectedTenant._id, // Só busca se houver um ID válido
    },
  ]);
  const gapAnalysisData = results[0].data?.data || [];

  return (
    <Container 
      title="Gap Analysis" 
      breadcrumb="Assessment / Gap Analysis" 
      showButtonAdd 
      linkPage="/gap-analysis"
      data-tour="page-title"
      addButtonDataTour="add-button"
    >
      <div data-tour="info-card">
      <Information
        title={'Gap Analysis'}
        description={
          <p className="m-0">
            <strong>Gap Analysis</strong> é uma ferramenta essencial para identificar discrepâncias entre o estado atual
            e o estado desejado de um processo, sistema ou organização. Ele pode abranger diferentes áreas, incluindo:
            <br />
            <br />
            &emsp;• <strong>Processos:</strong> Avaliação de fluxos de trabalho, ineficiências e oportunidades de
            melhoria.
            <br />
            &emsp;• <strong>Tecnologia:</strong> Identificação de deficiências em infraestrutura, softwares, segurança e
            integração de sistemas.
            <br />
            &emsp;• <strong>Conformidade:</strong> Análise de aderência a normas, regulamentos e políticas internas.
            <br />
            <br />A análise de gaps permite definir ações estratégicas para eliminar falhas e otimizar a operação.
          </p>
        }
        style={{
          marginTop: '24px',
          marginBottom: '24px',
        }}
      />
      </div>
      <div data-tour="table">
      <DefaultTable applyMB rows={tableHeader} cells={gapAnalysisData} hideEdit hideDelete showDashboard={true} link="gap-analysis" />
      </div>
      <PageHelper steps={tourSteps} tourKey="gap-analysis-list" />
    </Container>
  );
};

const tourSteps = [
  {
    target: 'body',
    content: 'Bem-vindo à página de Gap Analysis! Aqui você analisa e identifica lacunas entre o estado atual e o estado desejado de conformidade com frameworks de segurança.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'center',
  },
  {
    target: '[data-tour="page-title"]',
    content: 'Clique no título para voltar à página anterior.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="add-button"]',
    content: 'Use o botão "Adicionar" para criar uma nova análise de gap, selecionando frameworks e controles.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="info-card"]',
    content: 'Gap Analysis identifica diferenças entre processos atuais e desejados, cobrindo tecnologia, processos e conformidade regulatória.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="table"]',
    content: 'Esta tabela mostra todas as análises de gap. Cada análise possui status (Pendente, Em Andamento, Concluído), data de criação e última atualização. Clique no ícone de dashboard para visualizar os detalhes e progresso.',
    disableScrolling: false,
  },
  {
    target: 'body',
    content: 'Tour concluído! Agora você pode criar e gerenciar análises de gap para avaliar a conformidade da sua organização com frameworks de segurança.',
    disableScrolling: true,
    placement: 'center',
  },
];
